export enum BroadcastChannelsEnum {
  UserService = 'UserService',
  BookingService = 'BookingService'
}